export default "__VITE_ASSET__BYafFcIP__"